import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

// reactstrap components
import { Button, Card, CardBody, CardHeader, FormGroup, Form, Input, Row, Col } from "reactstrap";


// helpers
import { showMessage } from "../../helpers/message.js";
import { formateDateApi, dateAfterToDay } from '../../helpers/formats';

// api
import mapaentrada_api from "../../api/mapaentrada_api.js";

//Context
import { useAuth } from "../../context/auth.js";

export default function MapaEntradaForm({ item, handleReturn }) {
  const { session, setLoading } = useAuth();

  const { handleSubmit } = useForm({ mode: "onBlur" });

  const [form_disabled, set_form_disabled] = useState(false);

  const [list_table, set_list_table] = useState([]);

  const Voltar = () => {
    handleReturn();
  }

  useEffect(() => {
    loadForm();
  }, []);

  const loadForm = () => {
    setLoading(true);
    mapaentrada_api.getItemFromFicha(session.localId, item == null ? 0 : item.mapaEntradaId).then(result => {
      setLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        set_form_disabled(!dateAfterToDay(result.data.data));
        set_list_table(result.data.mapaEntradaTipoResiduo);
      }
    });
  }

  const handleQuantidadeChange = (tipoResiduoId, event) => {
    let _newlist = [];
    list_table.map(m => {
      if (m.tipoResiduoId == tipoResiduoId)
        m.quantidadeAdd = event.target.value;

      _newlist.push(m);
    })
    set_list_table(_newlist);
  }

  const handleAdd = (tipoResiduoId) => {
    let _newlist = [];
    list_table.map(m => {
      if (m.tipoResiduoId == tipoResiduoId && m.quantidadeAdd != null && m.quantidadeAdd != "") {
        m.quantidade = (m.quantidade != null ? m.quantidade : 0) + parseFloat(m.quantidadeAdd);
        m.quantidadeAdd = "";
      }

      _newlist.push(m);
    })
    set_list_table(_newlist);
  }

  const handleSubtract = (tipoResiduoId) => {
    let _newlist = [];
    list_table.map(m => {
      if (m.tipoResiduoId == tipoResiduoId && m.quantidadeAdd != null && m.quantidadeAdd != "") {
        m.quantidade = (m.quantidade != null ? m.quantidade : 0) - parseFloat(m.quantidadeAdd);
        m.quantidadeAdd = "";

        if (m.quantidade < 0)
          m.quantidade = 0;
      }

      _newlist.push(m);
    })
    set_list_table(_newlist);
  }

  const onSubmit = (data) => {
    if (list_table.filter(f => f.quantidade != null && f.quantidade != "").length == 0) {
      showMessage("Aviso", "Informe as quantidades do mapa de entrada", 'error', null);
      return;
    }

    let json_submit = {
      mapaEntradaId: item == null ? 0 : item.mapaEntradaId,
      localId: session.localId,
      data: formateDateApi(new Date()),
      mapaEntradaTipoResiduo: list_table.filter(f => f.quantidade != null && f.quantidade != "")
    }

    setLoading(true);
    if (json_submit.mapaEntradaId == 0)
      mapaentrada_api.post(json_submit).then(result => handleReturnSubmit(result));
    else
      mapaentrada_api.put(json_submit).then(result => handleReturnSubmit(result));
  }

  const handleReturnSubmit = (result) => {
    setLoading(false);
    if (result.status !== 200) {
      showMessage("Aviso", result.message, 'error', null);
    }
    else {
      showMessage("Aviso", "Operação executada com sucesso", "success", function () { handleReturn() });
    }
  }

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Button color="Primary" onClick={Voltar}><i className="fas fa-chevron-left"></i>  Voltar</Button>
            <Card>
              <CardHeader>
                <h4 className="titleCard">Ficha de Mapa de Entrada</h4>
              </CardHeader>
              <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <Row>
                    <Col md="12"><h6 className="subtitleCard">Lista de Resíduos</h6></Col>
                    <Col lg="5" md="5" sm="5">
                      <label className="form-control-label">Resíduo</label>
                    </Col>
                    <Col lg="2" md="2" sm="2">
                      <label className="form-control-label">Estoque</label>
                    </Col>
                    {!form_disabled &&
                      <Col lg="2" md="2" sm="2">
                        <label className="form-control-label">Quantidade</label>
                      </Col>
                    }
                    {!form_disabled &&
                      <Col lg="1" md="1" sm="1" className="text-center">
                        <label className="form-control-label">Ação</label>
                      </Col>
                    }
                    <Col lg="2" md="2" sm="2">
                      <label className="form-control-label">Entradas</label>
                    </Col>
                  </Row>
                  {list_table.map((m, key) => (
                    <Row key={key}>
                      <Col lg="5" md="5" sm="5">
                        <FormGroup>
                          <Input type="text" readOnly="true" value={m.tipoResiduoDescricao}></Input>
                        </FormGroup>
                      </Col>
                      <Col lg="2" md="2" sm="2">
                        <FormGroup>
                          <Input type="text" readOnly="true" value={m.quantidadeEstoque + " " + m.tipoResiduoUnidade}></Input>
                        </FormGroup>
                      </Col>
                      {!form_disabled &&
                        <Col lg="2" md="2" sm="2">
                          <FormGroup>
                            <Input type="number" disabled={form_disabled} value={m.quantidadeAdd} onChange={(e) => handleQuantidadeChange(m.tipoResiduoId, e)}></Input>
                          </FormGroup>
                        </Col>
                      }
                      {!form_disabled &&
                        <Col lg="1" md="1" sm="1" className="text-center p-0">
                          <Button className="btn-sm2x" type="button" onClick={() => handleSubtract(m.tipoResiduoId)}><i className="fas fa-minus"></i></Button>
                          {" "}
                          <Button className="btn-sm2x" type="button" onClick={() => handleAdd(m.tipoResiduoId)}><i className="fas fa-plus"></i></Button>
                        </Col>
                      }
                      <Col lg="2" md="2" sm="2">
                        <FormGroup>
                          <Input type="text" readOnly="true" value={m.quantidade != null ? (m.quantidade + " " + m.tipoResiduoUnidade) : ""}></Input>
                        </FormGroup>
                      </Col>
                    </Row>
                  ))}
                  {!form_disabled &&
                    <Row>
                      <Col md="12" className="text-center">
                        <Button color="success" className="btn-mobile" type="submit"><i className="fas fa-save"></i>  Salvar</Button>
                      </Col>
                    </Row>
                  }
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>

      </div>

    </>
  );
}

